<div class="container">
    <h2 class="bar">Appréciation</h2>
    <ng-rating-bar [value]="rating" 
                    (valueChange)="ratingValueChanged($event)" 
                    [ratingCount]="5" 
                    [ngClass]="this.starSize < 70 ? 'small' : 'large'" 
    ></ng-rating-bar>
    <h2 class="bar">Coté dérangeant</h2>
    <ng-rating-bar 
                [value]="disturbing" 
                (valueChange)="disturbingValueChanged($event)" 
                [ratingCount]="5" 
                [ngClass]="this.starSize < 70 ? 'small' : 'large'"
    ></ng-rating-bar>
</div>